import { Box, Button, Container, makeStyles, TextField, Typography, withStyles } from "@material-ui/core";
import { blue, } from "@material-ui/core/colors";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { loggingOut, loggingOutSuccess, loginAttempSuccess } from "../action/loginAction";
import { attempSubmit } from "../action/studentAction";
import Error from "./Error";
import Loading from "./Loading";
const useStyles = makeStyles({
    container: {
        minHeight: "100vh",
        height: "fit-content",
        minWidth: "515px",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "20px",
        padding: "60px",
    },
    error: {
        color: "red",
    },
    avatar: {
        width: "50px",
        height: "50px",
        cursor: "pointer",
        backgroundColor: "red",
        position: "absolute",
        top: "10px",
        right: "10px",
        borderRadius: "50%",
        "&:hover": {
            opacity: "0.7",
        }
    },
    textArea: {
        minWidth: "500px",
        width: "100%",
        fontSize: "100px",
    },
    wrapper: {
        display: "flex",
        gap: "20px"
    }
});

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(blue[900]),
        backgroundColor: blue[900],
        '&:hover': {
            backgroundColor: blue[700],
        },
    },
}))(Button);

export default function StudentSubmission() {
    let classes = useStyles();
    let history = useHistory();
    let user = useSelector(state => state.userState);
    let dispatch = useDispatch();
    let studentState = useSelector(state => state.studentState);
    let logOut = async () => {
        if (window.confirm("Are you sure you want to log out?")) {
            dispatch(loggingOut());
            await new Promise(resolve => setTimeout(resolve, 2000));
            localStorage.clear();
            dispatch(loggingOutSuccess());
            history.push("/");
        }
    }
    useEffect(() => {
        if (!user.user.email) {
            let loginData = JSON.parse(localStorage.getItem("UserLogin"));
            if (loginData.email) {
                dispatch(loginAttempSuccess(loginData));
            }
        }
        // eslint-disable-next-line
    }, [])
    let [students, setStudents] = useState("")

    let gotoDashboard = () => history.push("/dashboard")


    let validate = async () => {
        let hasError = false;
        let msg = "";
        let inputArr = students.split("\n").join(",").split(",");
        if (students === "") {
            hasError = true;
            msg = "Please enter students name.";
        }
        else {
            let temp
            let hasDuplicates = false;
            temp = inputArr.reduce((acc, val) => {
                if (val !== "") {
                    if (!acc.includes(val)) {
                        acc.push(val)
                    }
                    else hasDuplicates = true;
                }
                return acc;
            }, [])
            inputArr = temp;
            if (hasDuplicates) {
                hasError = true;
                msg = "There are duplication on student names. Please check it out."
            }
        }

        if (hasError) alert(msg);
        else {
            let tID = user.user.email.replace(".", "_");
            dispatch(attempSubmit(tID, inputArr, gotoDashboard));
        }
    }
    return (
        <>
            {!user.loggingOut &&
                <Container className={classes.container} fixed>
                    <img src={user.user.image} className={classes.avatar} onClick={() => logOut()} alt="Log out" />
                    {user.error + studentState.error !== "" &&
                        <Error error={user.error ? user.error : studentState.error} />
                    }
                    {user.error + studentState.error === "" &&
                        <>
                            <Typography variant="h2" >
                                My Students
                            </Typography>
                            <Typography variant="h6" >
                                Enter the names of each person who will answer your questions, seperated by comma or new line.
                            </Typography>
                            <TextField
                                className={classes.textArea}
                                multiline
                                defaultValue=""
                                rows={15}
                                variant="outlined"
                                onChange={(e) => setStudents(e.target.value)}
                            />
                            <Box className={classes.wrapper}>
                                <ColorButton variant="contained" onClick={validate}>Submit</ColorButton>
                                {studentState.loading && <Typography variant="h5">Submitting . . .</Typography>}
                                <h2 style={{ color: "red" }}>{studentState.error}</h2>
                            </Box>
                        </>
                    }
                </Container>
            }
            {user.loggingOut &&
                <Loading />
            }
        </>
    )
}